import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { headerLinksTexts } from "../../Components/Common/Header";
import InnerHeader from "../../Components/Common/InnerHeader";
import Login from "../../Components/Login/Login";
import BillInformation from "../../Components/Payment/BillInformation";
import BillInquire from "../../Components/Payment/BillInquire";
import Bills, {
  editBill,
  EditModule,
  Module,
  removeBill,
} from "../../Components/Payment/Bills";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";

export const getBills = (setBills, token, setBillsLoading) => {
  ApiCall(
    "get",
    `${urls.GetUserBills}`,
    null,
    "GetBills",
    token,
    function (e) {
      const data = e.data;
      setBills(data);
      setBillsLoading(false);
      // document.getElementById("companyImage") &&
      //   window.scrollTo({
      //     top: document.getElementById("companyImage").offsetTop,
      //     behavior: "smooth"
      //   });
    },
    function (error) {
      setBillsLoading(false);
    }
  );
};
export const getBillStatus = (billId, token, setPaymentStatus) => {
  ApiCall(
    "get",
    `${urls.BillStatus}${billId}`,
    null,
    "getBillStatus",
    token,
    function (e) {
      setPaymentStatus(e.data.payment_status);
    }
  );
};

const PaymentComponent = ({
  moduleVisible,
  setModuleVisible,
  billsLoading,
  setModuleID,
  moduleID,
  amount,
  payment,
  billName,
  billId,
  companyId,
  setBillId,
  setPayment,
  setBillName,
  setAmount,
  filteredBills,
  isLogin,
  token,
  setBills,
  date,
  setDate,
  setInfo,
  info,
  loading,
  setLoading,
  header,
  setEditModuleVisible,
  editModuleVisible,
  billTitle,
  setBillTitle,
  selectedBillId,
  setSelectedBillId,
  bills,
  billParam,
  setBillParam,
  btnActive,
  setBtnActive,
  paymentStatus,
  history,
}) => {
  return !payment ? (
    <>
      <BillInquire
        value={billId}
        header={header}
        companyId={companyId}
        setBillId={setBillId}
        setPayment={setPayment}
        setBillName={setBillName}
        setAmount={setAmount}
        isLogin={isLogin}
        setDate={setDate}
        setInfo={setInfo}
        setLoading={setLoading}
        loading={loading}
        setBillParam={setBillParam}
        history={history}
      />
      {isLogin && (
        <Bills
          bills={filteredBills}
          billsLoading={billsLoading}
          onClick={setBillId}
          onClickName={setBillName}
          setModuleID={setModuleID}
          setModuleVisible={setModuleVisible}
          setEditModuleVisible={setEditModuleVisible}
          setBillTitle={setBillTitle}
          setSelectedBillId={setSelectedBillId}
        />
      )}
      {moduleVisible && (
        <Module
          onClickNo={() => setModuleVisible(false)}
          onClickYes={() => {
            removeBill(moduleID, token, setBills, companyId, bills);
            setModuleVisible(false);
          }}
        />
      )}
      {editModuleVisible && (
        <EditModule
          onClickNo={() => setEditModuleVisible(false)}
          onClickYes={() => {
            editBill(billTitle, token, selectedBillId, bills, setBills);
            setEditModuleVisible(false);
          }}
          setBillTitle={setBillTitle}
          value={billTitle}
        />
      )}
    </>
  ) : (
    <BillInformation
      date={date}
      setState={setPayment}
      billId={billId}
      billParam={billParam}
      billName={billName}
      companyId={companyId}
      amount={amount}
      info={info}
      header={header}
      token={token}
      btnActive={btnActive}
      setBtnActive={setBtnActive}
      paymentStatus={paymentStatus}
    />
  );
};

function Payment({ isLogin, Open, token }) {
  const history = useHistory();
  const [billId, setBillId] = useState([]);
  const [billParam, setBillParam] = useState("");
  const [billsLoading, setBillsLoading] = useState(true);
  const [date, setDate] = useState("");
  const [info, setInfo] = useState("");
  const [bills, setBills] = useState("");
  const [selectedBillId, setSelectedBillId] = useState("");
  const [payment, setPayment] = useState(false);
  const [billName, setBillName] = useState("");
  const [paymentStatus, setPaymentStatus] = useState(0);
  const [amount, setAmount] = useState("");
  const [moduleVisible, setModuleVisible] = useState(false);
  const [editModuleVisible, setEditModuleVisible] = useState(false);
  const [moduleID, setModuleID] = useState("");
  const [loading, setLoading] = useState(false);
  const [billTitle, setBillTitle] = useState("");
  const [windowFocused, setWindowFocused] = useState(true);
  const [btnActive, setBtnActive] = useState(true);
  const currentPage = headerLinksTexts.filter(
    (i) => i.path === history.location.pathname
  )[0];
  const header = currentPage.text;
  const companyId = currentPage.companyId;
  function handleActivity(forcedFlag) {
    if (typeof forcedFlag === "boolean") {
      return forcedFlag ? setWindowFocused(true) : setWindowFocused(false);
    }

    return document.hidden ? setWindowFocused(false) : setWindowFocused(true);
  }

  useEffect(() => {
    payment && getBillStatus(billParam, token, setPaymentStatus);
    if (paymentStatus === 1 && windowFocused && payment) {
      toast.success("پرداخت قبض با موفقیت انجام شد", {
        position: "bottom-center",
      });
      setPayment(false);
      setBtnActive(true);
    }
  }, [windowFocused, payment, billParam, token, paymentStatus]);
  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      isLogin && getBills(setBills, token, setBillsLoading);
    }
    return () => {
      isSubscribed = false;
    };
  }, [payment, token, isLogin]);

  useEffect(() => {
    document.addEventListener("visibilitychange", handleActivity);
    return () => {
      document.removeEventListener("visibilitychange", handleActivity);
    };
  });
  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      window.scrollTo(0, 0);
      isLogin && getBills(setBills, token, setBillsLoading);
      setModuleVisible(false);
      setModuleID("");
      setLoading(false);
      setPayment(false);
      setBillId("");
      setBillName("");
      setAmount("");
    }
    return () => {
      isSubscribed = false;
    };
  }, [history.location, token, isLogin]);

  const filteredBills =
    bills && bills.filter((i) => i.bill_company_id === companyId);
  return (
    <div className="container">
      <InnerHeader isLogin={isLogin} />
      <PaymentComponent
        setModuleVisible={setModuleVisible}
        setModuleID={setModuleID}
        moduleID={moduleID}
        moduleVisible={moduleVisible}
        setBills={setBills}
        amount={amount}
        payment={payment}
        billName={billName}
        billId={billId}
        companyId={companyId}
        setBillId={setBillId}
        setPayment={setPayment}
        setBillName={setBillName}
        setAmount={setAmount}
        filteredBills={filteredBills}
        isLogin={isLogin}
        token={token}
        date={date}
        setDate={setDate}
        info={info}
        header={header}
        billTitle={billTitle}
        setBillTitle={setBillTitle}
        setInfo={setInfo}
        loading={loading}
        bills={bills}
        setLoading={setLoading}
        editModuleVisible={editModuleVisible}
        setEditModuleVisible={setEditModuleVisible}
        selectedBillId={selectedBillId}
        setSelectedBillId={setSelectedBillId}
        billParam={billParam}
        setBillParam={setBillParam}
        btnActive={btnActive}
        setBtnActive={setBtnActive}
        paymentStatus={paymentStatus}
        history={history}
        billsLoading={billsLoading}
      />

      {Open && <Login />}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    bills: state.persistedParams.bills,
    token: state.auth.token,
    Open: state.init.loginOpen,
    isLogin: state.auth.isLogin,
  };
};

export default connect(mapStateToProps)(Payment);
